import { runAfterWorkspaceNavigationGuards } from '../workspace/navigation/workspaceNavigationGuard';

/**
 * Route-sync effects must use the same async guard as explicit sidebar
 * navigation; otherwise a store-driven `navigate()` can unmount an active DOCX
 * editor while its latest revision is still uploading.
 */
export function runGuardedRouteNavigation(
  navigate: () => void,
): boolean {
  return runAfterWorkspaceNavigationGuards(navigate);
}
